import { chainConstants } from '@chainflip/utils/chainflip';
import useChainTracking from './useChainTracking';
import { type DepositChannel } from './useStateChainAccount';

export const useDepositExpiryTime = (channel: DepositChannel) => {
  const chain = channel.asset.chain.chainflipId;

  const chainTracking = useChainTracking({ enabled: true });

  let expiryTime: number | undefined;

  const expiryBlock = channel.depositChainExpiryBlock;
  const height = chainTracking?.[chain];

  if (height) {
    expiryTime = (expiryBlock - height) * chainConstants[chain].blockTimeSeconds;
  }

  return {
    expiryTime: expiryTime && expiryTime > 0 ? expiryTime : 0, // seconds
    isLoading: chainTracking === null,
  };
};
